import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import {
    PENDING_VERIFICATION_MESSAGE,
    PENDING_VERIFICATION_TITLE
} from "../../util/emissionPendingVerification";

// Texto del servicio (errors.error[].value); si no llega o está vacío se usa el mensaje fijo.
const getAlertMessage = (lock) => {
    const backendMessage = typeof lock?.backendMessage === "string" ? lock.backendMessage.trim() : "";
    return backendMessage || PENDING_VERIFICATION_MESSAGE;
};

// Sin botón de cerrar: el aviso permanece visible mientras la operación esté bloqueada.
const PendingVerificationAlert = ({ lock }) => (
    <div className="alert alert-danger pending-ticket-alert pending-verification-alert mb-5" role="alert" aria-live="assertive">
        <div className="pending-ticket-alert-icon">
            <FontAwesomeIcon icon={faExclamationTriangle} />
        </div>
        <div className="pending-verification-alert-body">
            <h2 className="h5 pending-ticket-alert-title">{PENDING_VERIFICATION_TITLE}</h2>
            <p className="mb-2">{getAlertMessage(lock)}</p>
            {lock?.pnr ? (
                <p className="mb-0 pending-ticket-alert-action">
                    Localizador: <span>{lock.pnr}</span>
                    {lock.orderId ? <span className="pending-verification-order"> · Orden: <span>{lock.orderId}</span></span> : null}
                </p>
            ) : null}
        </div>
    </div>
);

export default PendingVerificationAlert;
